import React, { Component } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import Script from 'react-load-script'
import Fade from 'react-reveal/Fade';
import './map-styles.css'

var Parse = require('parse');

export default class Feature extends Component {


  constructor(props) {
    super(props)

    Parse.initialize(process.env.REACT_APP_API_KEY)
    Parse.serverURL = process.env.REACT_APP_API_URL

    this.state = {
      mapToken: null
    }

  }

  handleScriptCreate() {
    this.setState({ scriptLoaded: false })
  }

  handleScriptError() {
    this.setState({ scriptError: true })
  }

  handleScriptLoad(e) {
    let mapkit = window.mapkit
    mapkit.init({
      authorizationCallback: function (done) {
        Parse.Cloud.run("getMapsToken", { originURL: process.env.REACT_APP_ORIGIN_URL }).then(token => {
          done(token)
        })
      }
    })

    var map = new mapkit.Map("map");
    map.showsPointsOfInterest = false

    Parse.Cloud.run('getUniversities').then(universities => {
      let annotations = universities.map(university => {
        let coordinate = new mapkit.Coordinate(university.get("location").latitude, university.get("location").longitude)
        var annotation = new mapkit.MarkerAnnotation(coordinate)
        annotation.title = university.get("acronym")
        annotation.subtitle = university.get("name")
        annotation.displayPriority = mapkit.Annotation.DisplayPriority.Low
        annotation.clusteringIdentifier = "id"
        return annotation
      })
      let names = universities.map(university => {
        let name = <Col xs key={university.id}><Fade><p id="landing-p"><strong>{university.get("name")}</strong></p></Fade></Col>
        return name
      })
      map.showItems(annotations)
      this.setState({ names: names })
    })
  }

  goToUniversity() {

  }

  render() {
    return (
      <div id="maps">
        <Row center='xs'>
          <Script
            url="https://cdn.apple-mapkit.com/mk/5.x.x/mapkit.js"
            onCreate={this.handleScriptCreate.bind(this)}
            onError={this.handleScriptError.bind(this)}
            onLoad={this.handleScriptLoad.bind(this)}
          />
          <Col xs={12}>
            <Row center='xs'>
              <h1 className="gradientH1">Available Universities</h1>
            </Row>
            <Row center='xs'>
              <p>UniversityGO is available at the following universities:</p>
            </Row>
            <Row center='xs' between='xs' id="university-list">
              {this.state.names}
            </Row>
          </Col>
        </Row>
        <div id="map" />
        <Row center='xs' between='xs' id="university-list">
          <Col xs={12}>
            <p id="landing-p"><a href='mailto:contact@universitygo.co?subject=University%20Request%20'>Contact us </a> to get your university on board.</p>
          </Col>
        </Row>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Views/Landing/Map/Map.js